export * from './stringToNumber.pipe';